import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { Worker } from '../SiteClasses';
import API from '../API';

var SearchCountryCityModal = (props: SearchCoreProps<{ city_name: string, zipcode: string }>)=>{
	return <SearchCoreModal
		title='Buscar ciudad'
		{...props}
		searchData={(query, page, page_size)=>{
			return API.searchCountryCity(query, page * page_size, page_size);
		}}
		pageSize={10}
		table={[
			{ name: 'Nombre', key: 'city_name', collapsing: false },
			{ name: 'Código postal', key: 'zipcode', collapsing: true, centered: true },
		]}
	/>
}

export default SearchCountryCityModal;